export const SNAPSHOT_EVENT_NAME = 'global-employee-snapshot';
